import type { AuthorSocial } from '../data/content'
import SocialIcon from './SocialIcon'

const SOCIAL_LABELS: Record<AuthorSocial['type'], string> = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  tiktok: 'TikTok',
  pinterest: 'Pinterest',
  twitter: 'Twitter',
}

export default function AuthorSocials({ socials }: { socials: AuthorSocial[] }) {
  if (socials.length === 0) return null

  return (
    <div className="mt-2 flex flex-wrap items-center gap-3">
      {socials.map((social) => (
        <a
          key={`${social.type}-${social.url}`}
          href={social.url}
          target="_blank"
          rel="noreferrer"
          aria-label={`${SOCIAL_LABELS[social.type] ?? social.type} profile`}
          className="grid size-11 place-items-center text-muted hover:text-rose"
        >
          <SocialIcon name={social.type} size={15} />
        </a>
      ))}
    </div>
  )
}
